import { LANDING_COMPONENT_TYPES } from './landingComponents';

// IMPORTANT: no nested <div> elements inside the marker element. The publish transformer
// matches the marker element up to the FIRST closing tag of the same name, so
// the visual placeholder uses only <span>/<p> (block via inline styles).
const bar = (width, height, color, radius, margin) =>
  `<span style="display:block;width:${width};height:${height};background:${color};border-radius:${radius};margin:${margin};"></span>`;

const fakeInput = () => bar('100%', '38px', '#f0f3f6', '8px', '0 0 10px');
const fakeButton = () => bar('100%', '42px', '#007eff', '999px', '14px 0 0');
const fakeOutlineButton = () =>
  '<span style="display:block;width:100%;height:42px;background:#fff;border:2px solid #007eff;box-sizing:border-box;border-radius:999px;margin:10px 0 0;"></span>';
const fakeLabel = () => bar('34%', '9px', '#dce2e5', '4px', '0 0 6px');

const fakeSlide = (width, color) =>
  `<span style="display:inline-block;width:${width};height:110px;background:${color};border-radius:12px;margin:0 4px;vertical-align:middle;"></span>`;

const fakeDots = () =>
  `<span style="display:block;text-align:center;margin:14px 0 0;">${['#007eff', '#dce2e5', '#dce2e5']
    .map(
      (color) =>
        `<span style="display:inline-block;width:8px;height:8px;border-radius:50%;background:${color};margin:0 4px;"></span>`,
    )
    .join('')}</span>`;

const placeholderCard = (title, body) =>
  [
    `<p style="margin:0 0 12px;font-weight:bold;font-size:15px;color:#1a1d1f;text-align:center;">${title}</p>`,
    body,
    '<p style="margin:12px 0 0;font-size:11px;color:#80858a;text-align:center;">Lead1 component — rendered at publish</p>',
  ].join('');

const PLACEHOLDERS = {
  [LANDING_COMPONENT_TYPES.leadForm]: placeholderCard(
    'Lead Form',
    fakeLabel() + fakeInput() + fakeButton(),
  ),
  [LANDING_COMPONENT_TYPES.callbackOrCall]: placeholderCard(
    'Callback or Call',
    fakeButton() + fakeOutlineButton(),
  ),
  [LANDING_COMPONENT_TYPES.clickToCall]: placeholderCard(
    'Click to Call',
    fakeButton(),
  ),
  [LANDING_COMPONENT_TYPES.gallery]: placeholderCard(
    'Gallery',
    `<span style="display:block;text-align:center;white-space:nowrap;overflow:hidden;">${fakeSlide('18%', '#eef2f5')}${fakeSlide('56%', '#dce2e5')}${fakeSlide('18%', '#eef2f5')}</span>${fakeDots()}`,
  ),
};

const CARD_STYLE =
  'max-width:480px;margin:0 auto;padding:24px;background:#ffffff;border:1px dashed #b6c2cc;border-radius:16px;font-family:sans-serif;';

const WIDE_STYLE =
  'max-width:100%;margin:0 auto;padding:20px;background:#ffffff;border:1px dashed #b6c2cc;border-radius:16px;font-family:sans-serif;';

const MARKER_STYLES = {
  [LANDING_COMPONENT_TYPES.leadForm]: CARD_STYLE,
  [LANDING_COMPONENT_TYPES.callbackOrCall]: CARD_STYLE,
  [LANDING_COMPONENT_TYPES.clickToCall]: CARD_STYLE,
  [LANDING_COMPONENT_TYPES.gallery]: WIDE_STYLE,
};

export const buildMarkerHtml = (type) =>
  `<div data-lead1-component="${type}" style="${MARKER_STYLES[type]}">${PLACEHOLDERS[type]}</div>`;

export const buildMarkerRow = (type) => ({
  cells: [1],
  columns: [
    {
      contents: [
        {
          type: 'html',
          values: {
            html: buildMarkerHtml(type),
            containerPadding: '10px',
          },
        },
      ],
      values: {},
    },
  ],
  values: {},
});
